<div *ngIf="jobId">
  <div *ngIf="jobListData" class="collection">
    <label>{{getWellName()}}:</label>
    <p-select [options]="jobListData" styleClass="fixed-width-dropdown" [(ngModel)]="selectedItem" (onChange)="onJobChange($event.value)" optionLabel="name" ></p-select>
    <div class="fa fa-question-circle icon-help" (click)="openHelp()"></div>
  </div>
</div>